module.exports = __webpack_public_path__ + "img/person_wanghui.2836d927.jpg";